import { apiClient } from "./authService";

/* =======================
   TYPES
======================= */

export type NoteType = "CREDIT_NOTE" | "DEBIT_NOTE";

/** Used for GET /notes */
export interface Note {
  id: number;
  type: NoteType;
  amount: number;
  invoiceId: number;
  status: string;
  createdAt: string;
  currency: string;
}

/** Used for POST /notes/credit & /notes/debit */
export interface NoteActionResponse {
  creditNoteId?: number;
  debitNoteId?: number;
  invoice: {
    id: number;
    status: string;
    balance: number;
    total: number;
    sourceReferenceId?: string;
    updatedAt?: string;
  };
}

/* =======================
   CREATE NOTES
======================= */

export const createCreditNote = async (payload: {
  invoiceId: number;
  amount: number;
  reason?: string;
}): Promise<NoteActionResponse> => {
  const res = await apiClient.post<NoteActionResponse>("/notes/credit", payload);
  return res.data;
};

export const createDebitNote = async (payload: {
  invoiceId: number;
  amount: number;
  reason?: string;
}): Promise<NoteActionResponse> => {
  const res = await apiClient.post<NoteActionResponse>("/notes/debit", payload);
  return res.data;
};

/* =======================
   LIST NOTES
======================= */

export const listNotes = async (params?: {
  invoiceId?: number;
  type?: NoteType;
  from?: string;
  to?: string;
}): Promise<Note[]> => {
  const res = await apiClient.get<Note[]>("/notes", { params });
  return res.data;
};
